/**
 * 是否有权限访问提现申请列表页面
 */
export const WITHDRAW_APPLY_LIST_PAGE_UUID =
  '40104f0d-7fc0-4010-bfe9-8a1eb535700d'
